module.exports = __webpack_public_path__ + "fonts/Comfortaa-Light.929fd78b.ttf";